<div class="message">
  <h2>Authentication Successful!</h2>
  <!-- You can add more content here if needed -->
</div>